import { recordChanged } from "common/helpers/Record";
import { SkuRecord } from "common/records/Sku";
import { RootState } from "common/reducers";

/**
 * Retrieves the value of a SKU identified by its ID.
 * @param {RootState} state - The root state of the application.
 * @param {number} skuId - The ID of the SKU to retrieve the value for.
 * @returns {string} The value of the SKU .
 */
export const skuValue = (state: RootState, skuId: number) => {
  return state.getIn(["skus", "byId", skuId, "value"]) as string;
};

/**
 * Retrieves the SKU record.
 * @param {RootState} state - The root state of the application.
 * @param {number} skuId - The ID of the SKU to retrieve the value for.
 * @returns {SkuRecord} SkuRecord
 */
export const skuRecord = (state: RootState, skuId: number) => {
  return state.getIn(["skus", "byId", skuId]) as SkuRecord;
};

/**
 * Retrieves the lastSavedSKU record.
 * @param {RootState} state - The root state of the application.
 * @param {number} skuId - The ID of the SKU to retrieve the value for.
 * @returns {SkuRecord} SkuRecord
 */
export const skuRecordByLastSavedId = (state: RootState, skuId: number) => {
  return state.getIn(["skus", "lastSavedById", skuId]) as SkuRecord;
};

/**
 * Checks if the SKU is dirty (i.e., has unsaved changes).
 * @param {RootState} state - The root state of the application.
 * @param {number} skuId - The ID of the SKU to check.
 * @returns {boolean} True if the SKU is dirty, false otherwise.
 */
export const skuChanged = (state: RootState, skuId: number): boolean => {
  let dirty = false;
  const currentSku = skuRecord(state, skuId);
  const lastSavedSku = skuRecordByLastSavedId(state, skuId);
  if (currentSku && lastSavedSku) {
    dirty = recordChanged(currentSku, lastSavedSku);
  }
  return dirty;
};
